var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mb-3",attrs:{"dense":"","text":"","type":"info","icon":"mdi-tablet"}},[_vm._v(_vm._s(_vm.$t("admin.phoneEditingHint")))])}
var staticRenderFns = []

export { render, staticRenderFns }